import { deepReads, hotSearchWords } from "@/mocks/content";

type TrendSectionProps = {
  onPickWord: (word: string) => void;
};

export default function TrendSection({ onPickWord }: TrendSectionProps) {
  return (
    <section id="deep" className="scroll-mt-16">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8">
          <p className="text-xs font-semibold uppercase tracking-widest text-accent-600">Deep Read</p>
          <h2 className="font-display mt-2 text-3xl text-foreground-950 md:text-4xl">深度盘点</h2>
          <p className="mt-2 text-sm text-foreground-600">
            不止吃瓜，也带你看清热闹背后正在发生的变化。
          </p>
        </div>

        <div className="grid gap-6 lg:grid-cols-3">
          {deepReads.map((d, idx) => (
            <article
              key={d.id}
              className={`group overflow-hidden rounded-2xl border border-background-200 bg-background-50 ${
                idx === 0 ? "lg:col-span-2 lg:row-span-2" : ""
              }`}
            >
              <div
                className={`relative w-full overflow-hidden ${
                  idx === 0 ? "h-56 md:h-72" : "h-44"
                }`}
              >
                <img
                  src={d.image}
                  alt={d.title}
                  title={`${d.title} 深度行业观察`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-medium text-background-50">
                  {d.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className={`font-bold leading-snug text-foreground-950 ${idx === 0 ? "text-xl" : "text-lg"}`}>
                  {d.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600 line-clamp-3">
                  {d.description}
                </p>
                <div className="mt-4 flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-book-open-line"></i>
                    阅读约 {d.readTime}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {d.views} 人读过
                  </span>
                  <a href="#deep" className="font-medium text-accent-600 hover:underline">
                    开始阅读
                    <i className="ri-arrow-right-line ml-0.5"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}

          {/* hot search words card */}
          <div className="rounded-2xl border border-background-200 bg-gradient-to-br from-secondary-500 to-secondary-600 p-5 text-background-50 lg:col-span-3">
            <div className="flex items-center gap-2">
              <i className="ri-focus-3-line text-xl"></i>
              <h3 className="font-display text-2xl">吃瓜热搜词</h3>
            </div>
            <p className="mt-1 text-sm text-background-50/85">
              点击热搜词，即可在热点速递中检索相关讨论。
            </p>
            <div className="mt-4 flex flex-wrap gap-2.5">
              {hotSearchWords.map((w) => (
                <button
                  key={w}
                  type="button"
                  onClick={() => onPickWord(w)}
                  className="whitespace-nowrap rounded-full bg-background-50/15 px-4 py-1.5 text-sm text-background-50 backdrop-blur transition-colors hover:bg-background-50 hover:text-secondary-700"
                >
                  <i className="ri-fire-line mr-1 text-xs"></i>
                  {w}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}